import React, { Suspense, lazy } from 'react';
import PagePreloader from '~components/page-preloader';

const DigestsItemPageToken = lazy(() => import('./index'))

function LawsItemPageTokenLazy(props) {
    return (
        <Suspense fallback={<PagePreloader />}>
            <DigestsItemPageToken {...props} />
        </Suspense>
    );
}

export default LawsItemPageTokenLazy;
export { LawsItemPageTokenLazy };



// WEBPACK FOOTER //
// ./src/routes/laws-digests-item-page-token/lazy.js